
import { useAuth } from "@/contexts/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { hasPermission } from "@/utils/permissions";
import { sidebarRoutes } from "./sidebarRoutes";
import DesktopSidebar from "./DesktopSidebar";
import MobileSidebar from "./MobileSidebar";

interface SidebarProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const Sidebar = ({ isOpen, setIsOpen }: SidebarProps) => {
  const { profile } = useAuth();
  const isMobile = useIsMobile();
  
  // Filter routes based on user permissions and roles
  const authorizedRoutes = sidebarRoutes.filter(route => {
    if (route.requiredPermission) {
      return hasPermission(profile?.role, route.requiredPermission);
    }
    if (route.allowedRoles) {
      return profile && route.allowedRoles.includes(profile.role);
    }
    return true;
  });

  // For desktop view
  if (!isMobile) {
    return <DesktopSidebar authorizedRoutes={authorizedRoutes} />;
  }

  // For mobile view
  return <MobileSidebar isOpen={isOpen} setIsOpen={setIsOpen} authorizedRoutes={authorizedRoutes} />;
};

export default Sidebar;
